// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f6136352","498":"236c4393","703":"cf2789b4"}[chunkId] + ".chunk.js";
};